import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    .job-search-bar {
      --tenable-input-line-height: var(--tenable-job-search-line-height, 1.5rem);
      position: relative;
    }

    .job-board-search-icon {
      position:absolute;
      top: var(--tenable-job-search-icon-top-padding, .75rem);
      right: var(--tenable-job-search-icon-right-padding, 1rem);
    }
  `,
];
